import {Injectable} from '@angular/core';
import {Subject} from "rxjs";
import {ApiService} from "./api/api.service";
import {CardDataService} from "../pages/saved-card-list/services/card-data.service";
import {SavedCardDto} from "../pages/saved-card-list/models/saved-card.models";

@Injectable({
  providedIn: 'root'
})
export class SavedCardService {

  blockedCard$: Subject<string> = new Subject<string>()
  activatedCard$: Subject<string> = new Subject<string>()
  makeMainCard$: Subject<string> = new Subject<string>()
  deleteCard$: Subject<SavedCardDto> = new Subject<SavedCardDto>()

  activatedCardCompleted$: Subject<string> = new Subject<string>()
  blockedCardCompleted$: Subject<string> = new Subject<string>()
  makeMainCardCompleted$: Subject<void> = new Subject<void>()
  deleteCardCompleted$: Subject<void> = new Subject<void>()

  constructor(
    private cardDataService: CardDataService
  ) {
    this.activatedCard$.subscribe({
      next: (res) => {
        this.activatedCard(res)
      }
    })

    this.blockedCard$.subscribe({
      next: (res) => {
        this.blockedCard(res)
      }
    })

    this.makeMainCard$.subscribe({
      next: (res) => {
        this.makeMainCard(res)
      }
    })

    this.deleteCard$.subscribe({
      next: (res) => {
        this.deleteCard(res.id)
      }
    })
  }

  activatedCard(id: string) {
    this.cardDataService.activatedCard(id).subscribe({
      next: () => {
        this.activatedCardCompleted$.next(id)
      }
    })
  }

  blockedCard(id: string) {
    this.cardDataService.blockedCard(id).subscribe({
      next: () => {
        this.blockedCardCompleted$.next(id)
      }
    })
  }

  makeMainCard(id: string) {
    this.cardDataService.makeMainCard(id).subscribe({
      next: () => {
        this.makeMainCardCompleted$.next()
      }
    })
  }

  deleteCard(id: string) {
    this.cardDataService.deleteCard(id).subscribe({
      next: () => {
        this.deleteCardCompleted$.next()
      }
    })
  }

}
